import React from 'react'
import Box from '@mui/material/Box'
import { alpha } from '@mui/material/styles'

import MuiTablePagination from './MuiTablePagination'
import {
  UI_COLOR_TEXT_FILTER_LABEL,
  UI_COLOR_TEXT_STRONG,
  UI_COLOR_WHITE
} from '../constants/uiColors'

export default function DesktopIndexPagination({
  ariaLabel = 'Paginacion',
  pagination,
  onPageChange,
  onRowsPerPageChange,
  sx
}) {
  return (
    <Box
      component="nav"
      aria-label={ariaLabel}
      sx={(theme) => ({
        mt: '0 !important',
        mb: -2,
        px: 0,
        minHeight: 42,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        borderTop: `1px solid ${alpha(theme.palette.text.primary, 0.12)}`,
        bgcolor: UI_COLOR_WHITE,
        ...(typeof sx === 'function' ? sx(theme) : sx)
      })}
    >
      <MuiTablePagination
        count={pagination.total_count}
        page={pagination.current_page}
        rowsPerPage={pagination.per_page}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        sx={{
          width: 'auto',
          minWidth: 0,
          '.MuiToolbar-root': {
            minHeight: '42px !important',
            height: 42,
            px: '0 !important',
            gap: 1.25,
            flexWrap: 'nowrap',
            alignItems: 'center',
            justifyContent: 'flex-end'
          },
          '.MuiTablePagination-spacer': {
            display: 'none'
          },
          '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
            my: '0 !important',
            color: UI_COLOR_TEXT_FILTER_LABEL,
            fontSize: 13,
            lineHeight: '24px',
            height: 24,
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'nowrap'
          },
          '.MuiTablePagination-input': {
            display: 'flex',
            alignItems: 'center',
            height: 24,
            mr: 1.25
          },
          '.MuiTablePagination-select': {
            display: 'flex',
            alignItems: 'center',
            height: '24px !important',
            minHeight: '24px !important',
            lineHeight: '24px',
            py: '0 !important',
            pt: '0 !important',
            pb: '0 !important',
            color: UI_COLOR_TEXT_STRONG,
            mr: 1,
            fontSize: 13,
            fontWeight: 500
          },
          '.MuiSelect-icon': {
            top: '50%',
            transform: 'translateY(-50%)'
          },
          '.MuiTablePagination-actions': {
            ml: 1
          },
          '.MuiTablePagination-actions .MuiIconButton-root': {
            width: 32,
            height: 32,
            padding: 0.5
          }
        }}
      />
    </Box>
  )
}
